<template>
     <div class="box01">
          <v-crumbs :crumbsType="192" @get_mxy="get_mxy"></v-crumbs>
          <!-- <div class="offer_top flex02">
               <div class="flex03">
                    <v-select02 :p_text="'文件名称'" :value_="formInfo.file_name" @serch="get_serch"
                         @empty="get_empty"></v-select02>
               </div>
          </div> -->
          <div class="form_box">
               <template>
                    <el-table ref="multipleTable" :data="list" style="width: 100%">
                         <el-table-column prop="id" label="ID" min-width="70"></el-table-column>
                         <el-table-column :width="240" prop="orders.company_id_name" label="公司名称"></el-table-column>
                         <el-table-column :width="170" label="订单类型">
                              <template slot-scope="scope">
                                   <span v-if="scope.row.type_id === 1">应收</span>
                                   <span v-if="scope.row.type_id === 2">应付</span>
                              </template>
                         </el-table-column>
                         <el-table-column :width="160" prop="orders.order_no" label="订单号"></el-table-column>
                         <el-table-column :width="160" prop="orders.mobile" label="手机号码"></el-table-column>
                         <el-table-column :width="160" prop="orders.email" label="电子邮箱"></el-table-column>
                         <el-table-column :width="160" prop="orders.price" label="价格"></el-table-column>
                         <el-table-column prop="createtime_text" label="时间"></el-table-column>
                         <!-- status    0申请中    1已审核 2审核失败-->
                         <el-table-column :width="170" prop="status_text" label="状态">
                              <template slot-scope="scope">
                                   <el-tooltip class="item" effect="dark" :content="scope.row.status_text" placement="top">
                                        <span class="dot dot_gray" v-if="scope.row.status === 0"></span>
                                        <span class="dot dot_red" v-if="scope.row.status === 1"></span>
                                        <span class="dot dot_green" v-if="scope.row.status === 2"></span>
                                   </el-tooltip>
                              </template>
                         </el-table-column>
                         <el-table-column label="操作" min-width="220" fixed="right">
                              <template slot-scope="scope">
                                   <el-button @click="get_audit(scope.row)" type="text" size="mini"
                                        :disabled="scope.row.status != 0">审核</el-button>
                              </template>
                         </el-table-column>
                    </el-table>
               </template>
          </div>
          <div class="pagination">
               <el-pagination background :page-size="formInfo.limit" :current-page="formInfo.page"
                    layout="prev, pager, next, jumper, sizes" :total="total"
                    :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]" @current-change="currentChange"
                    @size-change="handleSizeChange"></el-pagination>
          </div>
          <!-- 审核弹窗 -->
          <audit-popup ref="auditPopupRef" @ok="handlerAuditOk"></audit-popup>
     </div>
</template>

<script>
import crumbs from '../../components/crumbs/index.vue'; // 面包屑
import select02 from '../../components/select/index01.vue'; // 搜索框
import select01 from '../../components/select/index.vue'; // 选择器
import settleModal from '@/components/settle-modal/settle-modal.vue';
import settleVoucherModal from '@/components/settle-modal/settle-voucher-modal.vue';
import auditPopup from './components/audit_popup.vue';
import { approvalProcessListsApi, approvalProcessApplyApi, setCollectStatus, exportExcelApi, downHttpApi, updateReconciliationApi, updateInvoicingApi } from '@/api/index';
import { makeInvoiceArr, settlementArr } from '@/api/enum.js'
export default {
     components: {
          'v-crumbs': crumbs,
          'v-select01': select01,
          'v-select02': select02, settleModal, settleVoucherModal, auditPopup
     },
     data() {
          return {
               makeInvoiceArr,
               settlementArr,
               list: [],
               total: null,
               choose_id: [],
               detail_info: {},
               // 下拉选择框
               selectOption: [{
                    value: 1,
                    label: '未完成'
               }, {
                    value: 2,
                    label: '已完成'
               }],
               formInfo: {
                    page: 1,
                    limit: 10,
                    file_name: '', // 文件名称
               },
               downHttp: ''
          }
     },
     created() {
          this.get_list();
          this.downHttp = downHttpApi()

     },
     methods: {
          birthdEx(e) {
               console.log(e)
               exportExcelApi({ sid: e.id }).then(res => {
                    console.log('66666', res)
               })
          },
          get_mxy() {
               this.formInfo = {
                    page: 1,
                    limit: 10,
                    file_name: '', // 文件名称
               }
               this.get_list();
          },
          // 列表
          get_list() {
               approvalProcessListsApi(this.formInfo).then(res => {
                    res.data.data.forEach((n, k) => {
                         if (!n.remark) {
                              n.remark = '-';
                         }
                    })
                    this.list = res.data.data
                    // .map(item=>{
                    // 	item.make_invoice_text=!item.make_invoice ? '未开票':'已开票'
                    // 	item.settlement_text=!item.settlement ? '未结算':'已结算'
                    // 	return item;

                    // });
                    this.total = res.data.total;
               })
          },
          // 更新状态
          get_option(e, id) {
               setCollectStatus({
                    id: id,
                    status: e
               }).then(res => {
                    this.get_list();
                    this.$message.success('更新成功');
               })
          },
          //num  1开票 2对账
          setStatus(e, id, num) {
               let params = {
                    id: id
               }
               // updateReconciliationApi,updateInvoicingApi
               let apiFun = num != 1 ? updateReconciliationApi(params) : updateInvoicingApi(params)
               apiFun.then(res => {
                    console.log('更新成功', res);
                    this.get_list();
                    this.$message.success('更新成功');
               })
          },

          // 清空搜索
          get_empty(e) {
               this.formInfo.page = 1;
               this.formInfo.keyword = '';

               this.get_list();
          },

          // 点击页码数
          currentChange(newPage) {
               this.formInfo.page = newPage;
               this.get_list();
               window.scroll(0, 0);
          },
          // 点击一页请求数据
          handleSizeChange(num) {
               this.formInfo.page = 1;
               this.formInfo.limit = num;
               this.get_list();
               window.scroll(0, 0);
          },
          // 搜索
          get_serch(e) {
               if (!e) return this.$message('请输入文件名称');

               this.formInfo.page = 1;
               this.formInfo.file_name = e, // 文件名称 = e;
                    this.get_list();
          },

          // 审核弹窗
          get_audit(e) {
               this.$refs.auditPopupRef.open({ id: e.id });
               // this.$confirm('确定审核吗？', '提示', {
               // 	confirmButtonText: '确定',
               // 	cancelButtonText: '取消',
               // 	type: 'warning'
               // }).then(() => {
               // 	approvalProcessApplyApi({
               // 		id: e.id,
               // 	}).then(res => {
               // 		if (this.formInfo.page != 1 && this.list.length == 1) {
               // 			this.formInfo.page--
               // 		}
               // 		this.get_list();
               // 		this.$message.success('删除成功');
               // 	})
               // })
          },
          handlerAuditOk(val) {
               console.log('父接收回参', val)
               let params = {
                    id: val.id,
                    ...val.data
               };
               approvalProcessApplyApi(params).then(res => {
                    console.log('审核结果', res);
                    this.get_mxy();
               })
          },
          /* 结算弹窗 */
          openSettle(_id, type_id) {
               this.$refs.settleModalRef.open({ id: _id, type_id: type_id });
          },
          /* 凭证弹窗 */
          openSettleVoucher(_id, type_id) {
               this.$refs.settleVoucherModalRef.open({ id: _id, type_id: type_id });
          }
     }
}
</script>

<style lang="less" scoped>
.offer_top {
     margin-bottom: 15px;
}
</style>
